<template>
  <div>
    <div class="form-group">
      <label>{{ __("forms.PeopleRoles.role") }}</label>
      <select class="form-control" name="peopleRole[role_id]" v-model="roleId" @change="checkRoles()" >
        <option v-for="role in roles" :key="role.id" :value="role.id" >
          {{ role.name }}
        </option>
      </select>
    </div>
    <div v-if="showAlertAssociation">
        <i class="fas fa-exclamation-triangle" style="color: red"></i>
        <label>{{ __("misc.model_warning.peopleRole.multipleAssociationWithRole") }}</label>
        <i class="fas fa-exclamation-triangle" style="color: red"></i>
    </div>
    <div v-if="actual_people_role_relation.length">
        <div>
          <div class="form-group">
            <label>{{ __('forms.peopleRole.thereAreTotSubordinateWithThisResponsibleRole_part1') }}
               <b>{{ actual_people_role_relation.length }}</b> 
               {{ __('forms.peopleRole.thereAreTotSubordinateWithThisResponsibleRole_part2') }}
               <b>{{ person_name }}</b> 
               {{ __('forms.peopleRole.thereAreTotSubordinateWithThisResponsibleRole_part3') }}
                <b>{{ role_name }}</b>
            </label>
          </div>
          
            <input id="auto_sync_subordinate" checked="checked" name="auto_sync_subordinate" type="checkbox" value="1"> 
            <label for="auto_sync_subordinate">
              {{ __('forms.peopleRole.sync_role') }}
            </label>          
          <a class="btn btn-primary mb-2" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
            {{ __('forms.peopleRole.show_role_relation_subordinate') }}            
          </a>
        </div>
        <div class="collapse" id="collapseExample">
          <div class="card card-body">                      
              <div class="row">                  
                <div v-for="(name) in actual_people_role_relation" v-bind:key="name" class="col-6" v-html="name"></div>
              </div>
          </div>
        </div>  
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      roleId: null,      
      showAlertAssociation: false,      
    };
  },
  methods: {
    checkRoles() {
      axios.get("/person-role-association-number/person/" + this.person_id + "/role/" + this.roleId)
        .then((response) => {
          let associations = response.data;
          this.showAlertAssociation = associations >= 1;
        });
    },
  },
  mounted() {
    this.roleId = this.role_id;    
    this.initialRole = this.role_id;
  },
  props: {
    roles: {
      type: Array,
      required: true,
    },
    person_id: {
      type: Number,
      required: true,
    },
    person_name: {
      type: String,
      required: false,
    },
    role_id: {
      type: Number,
      required: true,
    },
    role_name: {
      type: String,
      required: false
    },
    actual_people_role_relation: {
      type: Array,
      required: false
    }
  },
};
</script>